export default "__VITE_ASSET__Rgv0p33T__"